const inherits = require('inherits');

const PropertiesActivator = require('bpmn-js-properties-panel/lib/PropertiesActivator');

const is = require('bpmn-js/lib/util/ModelUtil').is;

const processProps = require('bpmn-js-properties-panel/lib/provider/bpmn/parts/ProcessProps');
const eventProps = require('bpmn-js-properties-panel/lib/provider/bpmn/parts/EventProps');
const linkProps = require('bpmn-js-properties-panel/lib/provider/bpmn/parts/LinkProps');
const documentationProps = require('bpmn-js-properties-panel/lib/provider/bpmn/parts/DocumentationProps');
const idProps = require('bpmn-js-properties-panel/lib/provider/bpmn/parts/IdProps');
const nameProps = require('bpmn-js-properties-panel/lib/provider/bpmn/parts/NameProps');
const executableProps = require('bpmn-js-properties-panel/lib/provider/bpmn/parts/ExecutableProps');

const userTaskProps = require('./parts/UserTaskProps');

function createGeneralTabGroups(element, canvas, bpmnFactory, elementRegistry, translate) {
  const generalGroup = {
    id: 'general',
    label: translate('General'),
    entries: []
  };
  idProps(generalGroup, element, translate);
  nameProps(generalGroup, element, bpmnFactory, canvas, translate);
  processProps(generalGroup, element, translate);
  executableProps(generalGroup, element, translate);

  const detailsGroup = {
    id: 'details',
    label: translate('Details'),
    entries: []
  };
  linkProps(detailsGroup, element, translate);
  eventProps(detailsGroup, element, bpmnFactory, elementRegistry, translate);

  const parametersGroup = {
    id: 'shr-parameters',
    label: translate('Subscribe-HR Parameters'),
    entries: []
  };
  userTaskProps(parametersGroup, element, translate);

  const documentationGroup = {
    id: 'documentation',
    label: translate('Documentation'),
    entries: []
  };

  documentationProps(documentationGroup, element, bpmnFactory, translate);

  return [
    generalGroup,
    detailsGroup,
    parametersGroup,
    documentationGroup
  ];
}

/* function createVariablesTabGroups(element, bpmnFactory, elementRegistry, translate) {
    var variablesGroup = {
        id : 'variables',
        label : translate('Variables'),
        entries: []
    };
    variableMapping(variablesGroup, element, bpmnFactory, translate);

    return [
        variablesGroup
    ];
}*/

function BpmnPropertiesProvider(eventBus, canvas, bpmnFactory, elementRegistry, translate) {
  PropertiesActivator.call(this, eventBus);
  this.getTabs = function (element) {
    const generalTab = {
      id: 'general',
      label: translate('General'),
      groups: createGeneralTabGroups(element, canvas, bpmnFactory, elementRegistry, translate)
    };
        /* var variablesTab = {
            id: 'variables',
            label: translate('Variables'),
            groups: createVariablesTabGroups(element, bpmnFactory, elementRegistry, translate)
        };*/
    return [
      generalTab,
            //variablesTab
    ];
  };
}

BpmnPropertiesProvider.$inject = [
  'eventBus',
  'canvas',
  'bpmnFactory',
  'elementRegistry',
  'translate'
];

inherits(BpmnPropertiesProvider, PropertiesActivator);

module.exports = BpmnPropertiesProvider;



// WEBPACK FOOTER //
// ./src/client/common/bpmn-properties-provider/BpmnPropertiesProvider.js